import { createSelector } from "@ngrx/store";
import { ISolarAccountEsState } from "@edp-store/state/ES/solar-account-es.state";
import { IAppEsState } from "@edp-store/state/ES/app-es.state";

const solarAccountEsSelector = (state: IAppEsState) => state.solarAccountEs;

export const getSolarAccountEs = createSelector(solarAccountEsSelector, (state: ISolarAccountEsState) => state.solarAccountEs);

export const getSolarAccountEsAPIError = createSelector(solarAccountEsSelector, (state: ISolarAccountEsState) => state.lastAPIError);
